
export function RLParentEntityID() {
    var directive: ng.IDirective = {
        restrict: "A",
        controller: RLParentEntityIDController,
        controllerAs: "peiVM",
        scope: {
            parentEntityID: "=rlParentEntityId"
        },
        bindToController: true
    };
    return directive;
}

export class RLParentEntityIDController {

    parentEntityID: string;

    constructor() {

    }
}
